import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getUser } from "actions/user";
import PropTypes from "prop-types";

import { getLocale, initializeMoment } from "utils";
import { isAuthenticated } from "utils/Authenticated";

class Initializer extends React.Component {
  componentDidMount() {
    const { initializeCurrentUser } = this.props;

    if (isAuthenticated()) {
      initializeCurrentUser();
    }
  }

  render() {
    const { children } = this.props;

    return <>{children}</>;
  }
}

Initializer.propTypes = {
  children: PropTypes.node,
  initializeCurrentUser: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  initializeCurrentUser: () => {
    initializeMoment(getLocale());
    dispatch(getUser());
  },
});

export default withRouter(connect(null, mapDispatchToProps)(Initializer));
